import { topics } from '@/mocks/movies';

function getColorClasses(color: string) {
  switch (color) {
    case 'primary':
      return 'bg-primary-100 text-primary-800 hover:bg-primary-200';
    case 'accent':
      return 'bg-accent-100 text-accent-800 hover:bg-accent-200';
    case 'secondary':
      return 'bg-secondary-100 text-secondary-800 hover:bg-secondary-200';
    default:
      return 'bg-background-200 text-foreground-700 hover:bg-background-300';
  }
}

export default function Topics() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            影迷最关心的话题标签，发现你的下一部高分电影在线
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((item) => (
              <a
                key={item.id}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${getColorClasses(item.color)}`}
              >
                <span>{item.name}</span>
                <span className="text-xs opacity-70">{item.count}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}